// GA4 event helper. No-ops on preview (gtag only loads on production).
export function track(event, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", event, params);
  }
}
